<template>
    <b-dropdown
        size="sm"
        variant="outline-secondary"
        class="employee-name-format-switcher"
        boundary="viewport"
        right
        no-caret
        :aria-label="copyActions ? 'Формат и копирование ФИО' : 'Формат ФИО'"
    >
        <template #button-content>
            <i class="fas fa-user-tag" aria-hidden="true"></i>
            <span class="employee-name-format-switcher__desktop-label">
                <template v-if="copyActions">Формат ФИО и копирование</template>
                <template v-else>ФИО: {{ activeOption.label }}</template>
            </span>
            <span class="employee-name-format-switcher__mobile-label">ФИО</span>
            <i class="fas fa-chevron-down employee-name-format-switcher__chevron" aria-hidden="true"></i>
        </template>
        <b-dropdown-item-button
            v-for="option in options"
            :key="option.value"
            :active="option.value === value"
            @click="$emit('input', option.value)"
        >
            <span class="employee-name-format-switcher__option">
                <i
                    class="fas fa-check"
                    :class="{'is-hidden': option.value !== value}"
                    aria-hidden="true"
                ></i>
                <span>
                    <strong>{{ option.example }}</strong>
                    <small>{{ option.label }}</small>
                </span>
            </span>
        </b-dropdown-item-button>
        <template v-if="copyActions">
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-header>Копирование</b-dropdown-header>
            <b-dropdown-form class="employee-name-format-switcher__copy-options" @submit.stop.prevent>
                <b-form-checkbox
                    :checked="copyWithDetails"
                    size="sm"
                    @input="$emit('update:copyWithDetails', $event)"
                >
                    Добавлять гражданство и ГПХ
                </b-form-checkbox>
                <small>{{ activeOption.example }}<template v-if="copyWithDetails"> · РФ · ГПХ</template></small>
            </b-dropdown-form>
            <b-dropdown-item-button
                :disabled="!selectedCopyCount"
                @click="$emit('copy-selected')"
            >
                <span class="employee-name-format-switcher__copy-action">
                    <i class="far fa-copy" aria-hidden="true"></i>
                    <span>
                        <strong>Копировать выбранные</strong>
                        <small v-if="selectedCopyCount">
                            {{ selectedCopyCount }} ФИО
                        </small>
                        <small v-else>Сначала выберите номера строк</small>
                    </span>
                </span>
            </b-dropdown-item-button>
            <b-dropdown-item-button
                :disabled="!visibleCopyCount"
                @click="$emit('copy-visible')"
            >
                <span class="employee-name-format-switcher__copy-action">
                    <i class="fas fa-list" aria-hidden="true"></i>
                    <span>
                        <strong>Копировать все видимые</strong>
                        <small>{{ visibleCopyCount }} ФИО с учётом фильтров</small>
                    </span>
                </span>
            </b-dropdown-item-button>
        </template>
    </b-dropdown>
</template>

<script>
import nameFormat from '@/utils/employeeNameFormat';

export default {
    name: 'EmployeeNameFormatSwitcher',
    props: {
        value: {
            type: String,
            default: nameFormat.DEFAULT_EMPLOYEE_NAME_FORMAT
        },
        copyActions: {
            type: Boolean,
            default: false
        },
        copyWithDetails: {
            type: Boolean,
            default: false
        },
        selectedCopyCount: {
            type: Number,
            default: 0
        },
        visibleCopyCount: {
            type: Number,
            default: 0
        }
    },
    computed: {
        options() {
            return nameFormat.EMPLOYEE_NAME_FORMAT_OPTIONS;
        },
        activeOption() {
            return this.options.find(option => option.value === this.value)
                || this.options.find(option => (
                    option.value === nameFormat.DEFAULT_EMPLOYEE_NAME_FORMAT
                ));
        }
    }
};
</script>

<style scoped>
.employee-name-format-switcher {
    white-space: nowrap;
}
.employee-name-format-switcher__mobile-label { display: none; }
.employee-name-format-switcher__chevron {
    margin-left: 5px;
    font-size: 0.62rem;
}
.employee-name-format-switcher__option {
    display: flex;
    min-width: 210px;
    align-items: center;
    gap: 7px;
}
.employee-name-format-switcher__copy-action {
    display: flex;
    min-width: 230px;
    align-items: center;
    gap: 8px;
}
.employee-name-format-switcher__copy-options {
    width: 290px;
    max-width: calc(100vw - 48px);
    white-space: normal;
}
.employee-name-format-switcher__copy-options small {
    display: block;
    margin: 5px 0 0 24px;
    color: #52677a;
    font-size: 0.7rem;
    line-height: 1.4;
}
.employee-name-format-switcher__copy-action > i {
    width: 15px;
    color: #3978ad;
    text-align: center;
}
.employee-name-format-switcher__copy-action strong,
.employee-name-format-switcher__copy-action small { display: block; }
.employee-name-format-switcher__copy-action small {
    margin-top: 1px;
    color: #718092;
    font-size: 0.68rem;
}
.employee-name-format-switcher__option > i { width: 14px; }
.employee-name-format-switcher__option > i.is-hidden { visibility: hidden; }
.employee-name-format-switcher__option strong,
.employee-name-format-switcher__option small { display: block; }
.employee-name-format-switcher__option small {
    margin-top: 1px;
    opacity: 0.72;
    font-size: 0.7rem;
}

@media (max-width: 767.98px) {
    .employee-name-format-switcher__desktop-label { display: none; }
    .employee-name-format-switcher__mobile-label { display: inline; }
}
</style>
